import React, { useState, useEffect } from 'react'
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Typography, Box } from '@mui/material';

import Header from '../components/Header';
import Loading from '../components/Loading';
import Search from './Search';
import Data from './Data';
import { searchData, getSearchLimit, getFeatureFlags } from '../services/api';
import { dataTypeFromCode } from '../helpers/DataType';

const Home = (props) => { 
  const [isLoading, setIsLoading] = useState(false);
  const [dataType, setDataType] = useState('invoice');
  const [invoiceData, setInvoiceData] = useState([]);
  const [invoiceError, setInvoiceError] = useState(false);
  const [workOrderData, setWorkOrderData] = useState([]);
  const [workOrderError, setWorkOrderError] = useState(false);
  const [quoteData, setQuoteData] = useState([]);
  const [quoteError, setQuoteError] = useState(false);
  const [limit, setLimit] = useState(100);
  const [features, setFeatures] = useState({enableConvertWorkOrder: false});

  useEffect(() => {
    getLimit();
    getFlags();
  }, []);
  
  const getData = async (searchCriteria) => {
    setIsLoading(true);
    setInvoiceError(false);
    setQuoteError(false);
    setWorkOrderError(false);

    const [invoiceOutcome, workOrderOutcome, quoteOutcome] = await Promise.allSettled([
      searchData('invoices', searchCriteria),
      searchData('workorders', searchCriteria),
      searchData('quotes', searchCriteria)
    ]);

    if (invoiceOutcome.status === 'fulfilled') {
      setInvoiceData(invoiceOutcome.value);
    } else {
      setInvoiceError(true);
    }

    if (quoteOutcome.status === 'fulfilled') {
      setQuoteData(quoteOutcome.value);
    } else {
      setQuoteError(true);
    }

    if (workOrderOutcome.status === 'fulfilled') {
      setWorkOrderData(workOrderOutcome.value);
    } else {
      setWorkOrderError(true);
    }
      
    setIsLoading(false);
  }

  const getLimit = async () => {
    const response = await getSearchLimit();

    if (response && typeof response === 'object' && 'limit' in response) {
      setLimit(response.limit);
    } else {
      console.error('Invalid response or missing "limit" property:', response);
    }
  }
   
  const getFlags = async () => {
    const response = await getFeatureFlags();

    if (response && typeof response === 'object' && 'features' in response) {
      setFeatures(response.features);
    } else {
      console.error('Invalid response or missing "features" property:', response);
    }
  }

  const clearData = () => {
    setInvoiceData([]);
    setQuoteData([]);
    setWorkOrderData([]);
  }

  const chooseData = () => {
    if (dataType === 'invoice') {
      return invoiceData;
    } else if (dataType === 'quote') {
      return quoteData;
    } else if (dataType === 'workOrder') {
      return workOrderData;
    }
  }

  const chooseError = () => {
    if (dataType === 'invoice') {
      return invoiceError;
    } else if (dataType === 'quote') {
      return quoteError;
    } else if (dataType === 'workOrder') {
      return workOrderError;
    }
  }

  return (
    <>
      <Loading isLoading={isLoading} />
      <Header
        history={props.history}
        username={props.username}
      />
      <Box sx={{ width: '95%', margin: 'auto', marginTop: 5 }}>
        <Typography variant='h1'>Quote, WO, and Invoice Lookup Tool (QWILT)</Typography>
        <Search
          getData={getData}
          clearData={clearData}
        />
      </Box>
      <Data
        data={chooseData()}
        error={chooseError()}
        dataType={dataType}
        handleDataTypeChange={(e, value) => setDataType(dataTypeFromCode(value))} 
        limit={limit}
        features={features}
      />
    </>
    );
  }

export default withRouter(Home)

Home.propTypes = {
  history: ReactRouterPropTypes.history,
  isAdmin: PropTypes.bool.isRequired,
  storeId: PropTypes.string,
};
